<template>
  <div
    style="
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
    "
  >
    <vs-row style="align-items: center;">
      <vs-icon
        icon="directions_walk"
        size="30px"
        bg="#FFFCEC"
        round
        color="#F7D225"
      ></vs-icon>
      <h4 style="color: #fbae29; font-weight: bold" class="mt-1 ml-2">
        {{ header }}
      </h4>
      <vs-spacer /><h4>83% Spending</h4>
    </vs-row>
    <div class="mt-5" style="position: relative; width: 100%">
      <Chart
        :chartdata="type"
        height="300"
        :color="'#59B1EC'"
        :areaColor="'#ffd966a1'"
      />
    </div>
  </div>
</template>

<script>
import Chart from "./chart.vue";
export default {
  components: { Chart },
  props: ["type", "header"],
  data() {
    return {
      temp: { value: [], labels: [], tooltip_label: "Temperature ( °C )" },
      hum: { value: [], labels: [], tooltip_label: "Humidity ( % )" },
      heightofchart: 300,
    };
  },
};
</script>

<style>
</style>